import React from 'react'
import ModalInDrawer from '../ui/ModalInDrawer'

const VerPagoCotizacionDialog = ({open,onClose,imagen}) => {

    if(!open) return
  return (
    <ModalInDrawer activeModal={open} onClose={onClose}>

        <img
       
        className='object-contain w-full h-full rounded-md'
        src={imagen.url}
        />

    </ModalInDrawer>
  )
}

export default VerPagoCotizacionDialog